import { BACKEND_BASE_URL } from "./backendBaseUrl";

export const FOLDER_BASE_URL = BACKEND_BASE_URL + "/folder";
export const GET_FOLDER_ENVS = "/envs";
export const SHARE_FOLDER = "/share";
export const SHARE_ENV_LIST = "/share/envs";
export const FOLDER_DETAILS = "/details";
